import { cn } from '@/lib/cn';

const ProfileTypes = () => {
  const data = [
    {
      title: 'Produtor',
      description: 'Você cria e faz a gestão dos seus próprios produtos.'
    },
    {
      title: 'Agência',
      description: 'Gerencia os produtos de uma carteira de clientes.'
    },
    {
      title: 'Afiliado',
      description: 'Você divulga produtos de outros criadores e ganha comissão por cada venda realizada.'
    },
    {
      title: 'Co-produtor',
      description: 'Atua junto ao produtor na criação e gestão do produto, compartilhando responsabilidades.'
    },
    {
      title: 'Lançador',
      description: 'Especialista em estratégias de lançamento que impulsionam vendas.'
    },
    {
      description:
        'Eu já tenho uma certa experiência em vendas online e estou na fase de escalar meus produtos e negócio.'
    }
  ];

  return (
    <div className='bg-surface-disabled border-outline-disabled mt-4 flex w-100 flex-col items-center justify-center gap-2 rounded-lg border p-4'>
      {data.map((item, index) => (
        <div key={index} className='bg-default-product border-outline-default w-full gap-1 rounded-lg border p-4'>
          {item?.title && <p className='text-content-title mb-1! text-base font-semibold'>{item.title}</p>}

          <p className={cn('mb-1! text-sm', { 'text-content-body': item?.title, 'text-content-title': !item?.title })}>
            {item.description}
          </p>
        </div>
      ))}
    </div>
  );
};

export default ProfileTypes;
